<template>
  <Dialog
    v-model:visible="showModal"
    class="w-2/5 bg-white shadow rounded-xl"
    :modal="true"
  >
    <template #header>
      <div class="text-center"></div>
    </template>
    <div class="flex flex-col justify-center space-y-2 text-center w-full">
      <div class="pr-3">
        <svg
          width="72"
          height="50"
          viewBox="0 0 72 50"
          class="mx-auto"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36 2L51.3333 25L70.5 9.66667L62.8333 48H9.16667L1.5 9.66667L20.6667 25L36 2Z"
            fill="url(#paint0_linear)"
            stroke="url(#paint1_linear)"
            stroke-width="2.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="70.5"
              y1="2"
              x2="1.49977"
              y2="2.00033"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#E8C177" />
              <stop offset="0.71875" stop-color="#FADB76" />
            </linearGradient>
            <linearGradient
              id="paint1_linear"
              x1="70.5"
              y1="2"
              x2="1.49977"
              y2="2.00033"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#E8C177" />
              <stop offset="0.71875" stop-color="#FADB76" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <ul class="flex-1 space-y-2 mx-8">
        <li class="text-gray-900 font-semibold">這個功能需要升級才能使用</li>
        <li class="text-gray-500">現在升級嗎？</li>
      </ul>
    </div>
    <template #footer>
      <div class="w-full text-center py-4 border-gray-400">
        <button
          class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32"
          @click="showModal = false"
        >
          立刻升級
        </button>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";

export default {
  name: "LevelUpDialog",
  components: {
    Dialog
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function(value) {
        this.$emit("update:show", value);
      }
    }
  }
};
</script>

<style lang="scss" scope></style>
